import { HeadLogo } from "../components/headLogo";
import {ProfileStat} from "../components/profileStat";
import {CheckpointItem} from "../components/checkpointItem";
import {UserLevelInfo} from "../components/userLevelInfo";
import {BackButton} from "../components/backButton"
function ProfileView({
  firstName,
  Uid,
  userScore,
  progressPercentage,
  checkpointCount,
  completedQuests,
  checkpointList,
  onLogOut,
  onGotoCheckPoint,
}) {

  const maxCheckpoints = 10;
  const maxQuests = 80;

  return (
    <div className="profilePageContainer">
      <div className="mapOverview-profile">
      <HeadLogo />
       <BackButton title={firstName} />
      </div>

      <div className="profile-user-section">
        <div className="profile-user-info">
          <div className="profile-user-details">
            <UserLevelInfo points={userScore} />
            <div className="global-description">
              ID: {Uid && Uid.substring(0, 15)}
            </div>
          </div>
          <button onClick={onLogOut} className="profile-logout-btn">
            Log out
          </button>
        </div>

        <div className="profile-progress-container">
          <div className="profile-avatar-container">
            <div className="profile-avatar-wrapper">
              <div
                className="profile-avatar-progress"
                style={{ "--progress-percentage": progressPercentage || 0 }}
              ></div>
              <div className="profile-avatar">
                <div className="profile-avatar-placeholder"></div>
              </div>
              <div className="profile-avatar-overlay">
                {progressPercentage}%
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="profile-stats-container">
        <ProfileStat
          icon="icon_checkpoints"
          value={checkpointCount}
          maxValue={maxCheckpoints}
          label="Checkpoints"
        />

        <div className="profile-stat profile-stat-center">
          <ProfileStat
            icon="icon_points"
            value={userScore}
            maxValue={1000}
            label="Points"
          />
        </div>
        <ProfileStat
          icon="icon_quests"
          value={completedQuests}
          maxValue={maxQuests}
          label="Quests"
        />
      </div>

      <div className="profile-checkpoint-section">
        <div className="profile-checkpoint-header">
          <div className="profile-checkpoint-title global-h2_section_title">
            Checkpoint list
          </div>
        </div>

        <div className="profilepage-checkpoint-list">
          {checkpointList.map((cp) => (
            <CheckpointItem
              key={cp.id}
              checkpoint={cp}
              onClick={onGotoCheckPoint}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export { ProfileView };
